














import Vue from 'vue'
import { get } from 'vuex-pathify'
import Forbidden from './views/forbidden.vue'
import NotFound from './views/not-found.vue'
import RateLimitExceeded from './views/rate-limit-exceeded.vue'
import ServerError from './views/server-error.vue'
import ServiceUnavailable from './views/service-unavailable.vue'
import imageFile from '@/assets/img/logos/logo-donedone.svg'

export default Vue.extend({
  name: 'ErrorPage',

  metaInfo(): any {
    return {
      title: this.error,
    }
  },

  components: {
    Forbidden,
    NotFound,
    RateLimitExceeded,
    ServerError,
    ServiceUnavailable,
  },

  data() {
    return {
      logo: {
        src: imageFile,
        alt: 'Logo DoneDone',
      },
      marketingWebsiteUrl: 'https://www.donedone.com/',
    }
  },

  computed: {
    error: get('app/error'),
  },

  created() {
    if (this.error === 401) {
      window.location.href = process.env.VUE_APP_SERVER_SIDE_APP_URL
    }
  },
})
